/**
 * city/vegetation/trees.js
Dựng thảm thực vật cây xanh đô thị: Phượng vĩ, bàng, dừa, hoa sữa, bằng lăng, cây đa, khóm tre, chuối, chậu quất
 */

import { registerTreePartsMethods } from './tree-parts.js';
import { registerTreesTropicalMethods } from './trees-tropical.js';
import { registerTreesOtherMethods } from './trees-other.js';

class MethodsHolder {
  // Điều phối tạo cây theo loại
  createTree(kind, options = {}) {
    switch (kind) {
      case 'phuong':
        return this.createPoincianaTree(options);
      case 'bang':
        return this.createTerminaliaTree(options);
      case 'dua':
        return this.createPalmTree(options);
      case 'hoa_sua':
        return this.createMilkwoodTree(options);
      case 'bang_lang':
        return this.createLagerstroemiaTree(options);
      case 'cay_da':
        return this.createBanyanTree(options);
      case 'khom_tre':
        return this.createBambooClump(options);
      case 'chuoi':
        return this.createBananaTree(options);
      case 'chau_quat':
        return this.createPottedPlant('quat', options);
      case 'chau_hoa_giay':
        return this.createPottedPlant('hoa_giay', options);
      case 'chau_cau':
        return this.createPottedPlant('cau', options);
      default:
        return this.createTerminaliaTree(options);
    }
  }
}

export function registerVegetationMethods(proto) {
  registerTreePartsMethods(proto);
  registerTreesTropicalMethods(proto);
  registerTreesOtherMethods(proto);

  Object.getOwnPropertyNames(MethodsHolder.prototype).forEach((name) => {
    if (name !== 'constructor') {
      proto[name] = MethodsHolder.prototype[name];
    }
  });
}
